import { useTranslation } from "react-i18next";
import { PublicUserSignupErrorCode } from "../../../generated/graphql";
import { ErrorMessageBanner } from "../ErrorMessage";

export const PublicUserCreateAccountErrorMessage = ({
  error,
}: {
  error: { code?: PublicUserSignupErrorCode };
}) => {
  const { t } = useTranslation();

  switch (error.code) {
    case PublicUserSignupErrorCode.EMAIL_INVALID: {
      return (
        <ErrorMessageBanner>{t("signup-email-invalid")}</ErrorMessageBanner>
      );
    }
    case PublicUserSignupErrorCode.EMAIL_REQUIRED: {
      return <ErrorMessageBanner>{t("email-is-required")}</ErrorMessageBanner>;
    }
    case PublicUserSignupErrorCode.PASSWORD_INVALID: {
      return (
        <ErrorMessageBanner>{t("sign-up-password-invalid")}</ErrorMessageBanner>
      );
    }
    case PublicUserSignupErrorCode.SIGNUP_ERROR: {
      return <ErrorMessageBanner>{t("signup-error")}</ErrorMessageBanner>;
    }
    case PublicUserSignupErrorCode.PASSWORD_REQUIRED: {
      return (
        <ErrorMessageBanner>{t("sign-up-password-invalid")}</ErrorMessageBanner>
      );
    }
    default: {
      return <ErrorMessageBanner>{t("signup-error")}</ErrorMessageBanner>;
    }
  }
};
